<template>
  <svg
    width="24"
    height="29"
    viewBox="0 0 24 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="17"
      r="10"
      stroke="url(#paint0_linear_1_205)"
      stroke-width="3"
      class="stroke"
    />
    <path
      d="M12 17L12 13.25"
      stroke="url(#paint1_linear_1_205)"
      stroke-width="3"
      stroke-linecap="round"
      class="stroke"
    />
    <path
      d="M18.875 8.875L20.75 7"
      stroke="url(#paint2_linear_1_205)"
      stroke-width="3"
      stroke-linecap="round"
      class="stroke"
    />
    <path
      d="M9.58519 2.46324C9.72762 2.33034 10.0415 2.21291 10.4781 2.12915C10.9147 2.0454 11.4497 2 12 2C12.5503 2 13.0853 2.0454 13.5219 2.12915C13.9585 2.21291 14.2724 2.33034 14.4148 2.46324"
      stroke="url(#paint3_linear_1_205)"
      stroke-width="3"
      stroke-linecap="round"
      class="stroke"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_205"
        x1="12"
        y1="7"
        x2="12"
        y2="27"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_205"
        x1="12.5"
        y1="13.25"
        x2="12.5"
        y2="17"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_205"
        x1="19.8125"
        y1="7"
        x2="19.8125"
        y2="8.875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1_205"
        x1="12"
        y1="2"
        x2="12"
        y2="3.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style scoped>
svg .stroke {
  stroke: #df252a;
}
</style>
